import Config from '@config';

import { injectAdminSlice } from '@/app/adminApi';

import {
  AdminOrganizationReadModel,
  CreateAdminOrganizationRequest,
} from './types';

export const adminOrganizationApi = injectAdminSlice({
  baseUrl: Config.VITE_API_URL,
  tagTypes: ['AdminOrganization'],
  endpoints: builder => ({
    getAdminOrganization: builder.query<
      AdminOrganizationReadModel | null,
      void
    >({
      query: () => ({ url: '/admin-organizations', method: 'GET' }),
      providesTags: ['AdminOrganization'],
    }),
    createAdminOrganization: builder.mutation<
      string,
      CreateAdminOrganizationRequest
    >({
      query: data => ({
        url: '/admin-organizations',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['AdminOrganization'],
    }),
  }),
});

export const {
  useGetAdminOrganizationQuery,
  useCreateAdminOrganizationMutation,
} = adminOrganizationApi;
